// local
import { DA_URL } from './constants.js';
// packages

import {
  createFeed,
  createRaceFeed,
  createCandidateLookup,
  createSubunitLookup,
} from './stores.js';

import {
  renderSvelteComponent,
  findSvelteComponentContainer,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import Results from './components/Results.svelte';

/**
 * @type {Map<string, import('../types.jsjs').Crosswalk>}
 */
const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  const apfeed = await createFeed(DA_URL);
  const daFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createRaceFeed(apfeed, 'CA-D8620-2024-11-05')
  );

  let daContainer = findSvelteComponentContainer('#District-Attorney');

  renderSvelteComponent(
    Results,
    /** @type {HTMLElement} */
    daContainer,
    {
      feed: daFeed,
      face: false,
      crosswalk,
    }
  );
}

main().catch(console.error);
